// services/hooks/useGetInvestorInfoMBAPL.ts
import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { GET_INVESTOR_INFO } from "./apiRoutes";

export interface InvestorInfoFilters {
  investorType?: string;
  investorSubType?: string;
  type?: string;
  year?: number;

  // sorting
  sortBy?: string;
  sortOrder?: "ASC" | "DESC";
}


/**
 * Build URL only for provided filters.
 * Always allow empty params → backend returns full list.
 */
const getInvestorInfo = async (filters: InvestorInfoFilters = {}) => {
  const query = new URLSearchParams();

  // 🔹 DEFAULT SORTING (ALWAYS APPLIED)
  const sortBy = filters.sortBy || "date";
  const sortOrder = filters.sortOrder || "DESC";

  query.append("sortBy", sortBy);
  query.append("sortOrder", sortOrder);

  // 🔹 OPTIONAL FILTERS
  if (filters.investorType) {
    query.append("investorType", filters.investorType);
  }

  if (filters.investorSubType) {
    query.append("investorSubType", filters.investorSubType);
  }

  if (filters.type) {
    query.append("type", filters.type);
  }

  if (filters.year) {
    query.append("year", filters.year.toString());
  }

  const url = `${GET_INVESTOR_INFO}?${query.toString()}`;

  return axiosAuth.get(url);
};

const useGetInvestorInfoMBAPL = (
  filters: InvestorInfoFilters = {}
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["investor-info-mba-pl", filters],
    queryFn: () => getInvestorInfo(filters),
    select: (res: any) => res.data,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 2,
    enabled: true,
  });
};

export default useGetInvestorInfoMBAPL;

